import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import LocaleFactory from "./LocaleFactory";
import LanguageFactory from "./LanguageFactory";

import { AgencySettings } from "../Entities/Settings/Agency/AgencySettings";
import { AgencySettingsInterface } from "../Entities/Settings/Agency/AgencySettingsInterface";

class AgencySettingsFactory extends Factory implements FactoryInterface {

  public create(data: any): AgencySettingsInterface {
    /*
    |  Some entities doesn't have settings. (e.g tenants or owners)
    |  So if the data is undefined, we have to load defaults.
    */

    if (typeof data === "undefined") {
      return new AgencySettings({
        defaultLocale: LocaleFactory.create({ iso: "nl-NL" }),
        defaultLanguage: LanguageFactory.create({ iso: "nl-NL" }),
        defaultCalculation: "",
        financialStartDate: null,
        notificationPeriod: 2,
        isBusy: false,
        vatPercentage: 21,
        isActivitiesShown: false,
        isActivateInvoiceNumber: false,
        reviewOwnerStatements: false,
        statementEmailTextEn: "",
        statementEmailTextNl: "",
        adjustRentEmailTextEN: "",
    adjustRentEmailTextNL: "",
        useAgencyNameForEmail: false,
        sendCopyToEmails: [],
        sendCopyToSubject: "",
        useAgencyAsSenderForAutoEmails: true,
      });
    }

    return new AgencySettings({
      defaultLocale: LocaleFactory.create({ iso: data.defaultLocale }),
      defaultLanguage: LanguageFactory.create({ iso: data.defaultLanguage }),
      defaultCalculation: data.defaultCalculation,
      financialStartDate: !!data.financialStartDate ? new Date(data.financialStartDate) : null,
      notificationPeriod: data.notificationPeriod,
      isBusy: data.isBusy,
      vatPercentage: data.vatPercentage,
      isActivitiesShown: data.isActivitiesShown,
      isActivateInvoiceNumber: data.isActivateInvoiceNumber,
      reviewOwnerStatements: data.reviewOwnerStatements,
      statementEmailTextEn: data.statementEmailTextEn,
      statementEmailTextNl: data.statementEmailTextNl,
      adjustRentEmailTextEN: data.adjustRentEmailTextEN,
      adjustRentEmailTextNL: data.adjustRentEmailTextNL,
      useAgencyNameForEmail: data.useAgencyNameForEmail,
      sendCopyToEmails: (data.sendCopyToEmails || []),
      sendCopyToSubject: data.sendCopyToSubject,
      useAgencyAsSenderForAutoEmails: data.useAgencyAsSenderForAutoEmails,
    });
  }

  public reinitialize(data: any): AgencySettingsInterface {
    return new AgencySettings({
      ...data
    });
  }
}

export default new AgencySettingsFactory();
